import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useResetPassword } from '../../store/query/userQuery';



export const useResetPasswordForm = (token) => {

  const [showNewPassword,setShowNewPassword] = useState(false);
  const [showConfirmNewPassword,setShowConfirmNewPassword] = useState(false);

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleConfirmNewPasswordVisibility = () => {
    setShowConfirmNewPassword((prev) => !prev);
  };

  const [alert, setAlert] = useState({
    open: false,
    severity: 'success',
    message: '',
  });
  
  const navigate = useNavigate();
  const { mutate: resetPasswordMutate, isLoading } = useResetPassword();

  const handleClose = () => {
    setAlert((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const showToast = (msg, sev = 'success') => {
    setAlert({
      open: true,
      severity: sev,
      message: msg,
    });
  };

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirm: ''
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .required('Password is required'),
      passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required')
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        
        await resetPasswordMutate(
          { 
            token, 
            password: values.password, 
            passwordConfirm: values.passwordConfirm 
          },
          {
            onSuccess: () => {
              showToast('Password reset successful! Redirecting to login page...', 'success');
              
              setTimeout(() => {
                navigate('/');
              }, 3000);
            },
            onError: (err) => {
              showToast(
                err.response?.data?.message || 'An error occurred. Please try again.',
                'error'
              );
            }
          }
        );
      } catch (err) {
        showToast(
          err.response?.data?.message || 'An error occurred. Please try again.',
          'error'
        );
      } finally {
        setSubmitting(false);
      }
    }
  });

  return {
    alert,
    isLoading,
    formik,
    handleClose,
    showToast,
    showNewPassword,
    showConfirmNewPassword,
    toggleNewPasswordVisibility,
    toggleConfirmNewPasswordVisibility
  };
};
